var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "na",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    fill: "black",
    fillOpacity: 0.75,
    d: "M28.9,57.1c-1.9,0.2-3.9,0-5.5-1.3c-1.3-1.1-2.1-2.4-2.2-3.8c-0.2-1.5,0.3-2.9,1.4-4.4c1.1-1.4,3-2.3,5.7-2.7 c1.3-0.2,2.6-0.3,4-0.3c1.4,0,2.7,0.1,4.1,0.3c0.1-1.1,0.2-2.4,0.2-3.9V29.8c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.7-0.5,1.1-0.5 c0.5,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.2V41c0,1.5-0.1,3-0.2,4.4c2.8,0.5,5.5,1.1,8.1,2c2.6,0.8,5,1.7,7.1,2.5 c0.4,0.2,0.7,0.4,0.9,0.8c0.2,0.4,0.2,0.8,0,1.2c-0.2,0.4-0.4,0.7-0.8,0.9c-0.4,0.2-0.8,0.2-1.2,0c-2.1-0.8-4.4-1.5-6.9-2.4 c-2.5-0.8-5.1-1.4-7.8-1.9c-0.5,2.2-1.6,4.1-3.1,5.6C34.4,55.7,32.1,56.7,28.9,57.1L28.9,57.1z M28.5,53.8c1.6-0.2,3.2-0.6,4.6-1.5 c1.2-0.8,2.2-2.2,2.8-4.3c-1.2-0.1-2.4-0.1-3.6-0.2c-1.2,0-2.4,0.1-3.6,0.2c-1.6,0.2-2.8,0.7-3.5,1.4c-0.7,0.7-1,1.4-0.9,2.2 c0.1,0.6,0.5,1.2,1.2,1.7C26.2,53.8,27.2,54,28.5,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_4",
    fill: "none",
    stroke: "red",
    strokeWidth: 3.6,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.3,28.2L38.2,43c0,7-2.9,12.4-10.5,12.6c-5.6,0.2-6.6-6.4-2.3-8.3c3.6-1.6,7.2-1.2,11-0.8 c7.5,0.8,13.2,2.9,19.5,5.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    fill: "black",
    fillOpacity: 0.75,
    d: "M44.6,28.9L44.6,28.9c-0.4,0.2-0.8,0.3-1.2,0.2c-0.4-0.1-0.8-0.3-1-0.7c-0.2-0.4-0.3-0.8-0.2-1.2 c0.1-0.4,0.3-0.7,0.7-0.9l6.6-4L39,16.6c-0.4-0.2-0.6-0.5-0.8-0.9c-0.1-0.4-0.1-0.8,0.1-1.2c0.2-0.4,0.6-0.6,1.2-0.6 c0.6,0,0.9,0,0.9,0l12.9,6.9c0.5,0.3,0.8,0.7,0.9,1.3c0,0.6-0.3,1.1-0.8,1.5L44.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    fill: "none",
    stroke: "red",
    strokeWidth: 3.6,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.4,14.4c4.8,2.6,9.5,5.1,14.3,7.7c-3.4,2.1-6.9,4.2-10.3,6.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    fill: "black",
    fillOpacity: 0.75,
    d: "M19.6,28c-1.2,2.5-2.7,4.8-4.4,6.9c-1.7,2.1-3.6,3.8-5.6,5.2c0,0-0.1,0.3-0.4,0.9c-0.3,0.6-0.3,1,0,1.4 c0.3,0.4,0.6,0.6,1,0.7c0.4,0.1,0.8,0,1.2-0.3l0,0c2.4-1.6,4.7-3.7,6.6-6.2c2-2.5,3.6-5.2,5-8.2c2.7-6.1,4.4-14.4,3.2-21 c-0.1-0.5-0.3-0.8-0.7-1.1C25.2,6,24.8,5.9,24.4,6c-0.4,0.1-0.8,0.3-1,0.7C23.1,7,23,7.4,23,7.9c0.3,1.3,0.4,2.8,0.4,4.2 C23.5,17.3,21.9,23.4,19.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    fill: "none",
    stroke: "red",
    strokeWidth: 3.6,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.4,6c1.8,7.9,0.3,15.1-2.7,21.6c-2.6,5.8-6.6,11.1-12.5,14.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    fill: "black",
    fillOpacity: 0.75,
    d: "M34.5,16.7c0,0,0.2-0.2,0.7-0.7c0.4-0.4,0.6-0.9,0.5-1.3c-0.1-0.4-0.4-0.7-0.8-0.9c-0.4-0.2-0.8-0.3-1.2-0.1 c-7.8,2.2-15.6,4.4-23.3,6.6c-0.4,0.1-0.7,0.4-0.9,0.8c-0.2,0.4-0.3,0.8-0.1,1.2c0.1,0.4,0.4,0.7,0.8,0.9c0.4,0.2,0.8,0.3,1.2,0.2 C19,21.1,26.7,18.9,34.5,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_1",
    fill: "none",
    stroke: "red",
    strokeWidth: 3.6,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.2,22.2c8.8-2.5,17.6-5,26.4-7.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.aa8fade91e91e486fc83525bdef70680.svg";
export { ForwardRef as ReactComponent };